import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static values = { mobileMenuOpen: { type: Boolean, default: false } }

  toggleMobileMenu() {
    this.mobileMenuOpenValue = !this.mobileMenuOpenValue
  }
}
